module.exports = __webpack_public_path__ + "img/straight-rail-horizontal-stone-path-background-remnants.f1d1419d.png";